<template>
  <section>
    <b-row align-content="center" style="background: #f6f6f6;">
      <b-col sm="12" class="pl-3 mt-2">
        <a
          data-bs-toggle="modal"
          style="cursor: pointer;"
          data-bs-target="#img_modal"
        >
        <b-img
          v-if="$store.state.user.couple_image_large"
          class="avatarImg"
          center
          fluid
          :src="$store.state.user.couple_image_large"
          alt="Image 1"
        />
      </a>
        <b-img
        v-if="!$store.state.user.couple_image_large"
          class="avatarImg"
          center
          fluid
          src="https://cdn.trailfinders.com/images/2808853/iStock-1021697344%20copy.jpg?width=300"
          alt="Image 1"
        />
      </b-col>

      <b-col
        sm="12"
        v-if="
          $store.state.tabIdx === 0 &&
            this.$route.params.wishlistType !== 'friends-and-family'
        "
      >
        <div class="form-group form-group-venue text-center">
          <b-row align-content="center">
            <b-col sm="3"></b-col>

            <b-col :sm="colWidth" class="ml-2 mr-1">
              <b-form-group label="" class="text-center pt-2">
                <b-form-file class="input-group mx-auto"
                  style="width:80%;"
                  v-model="image"
                  type="file"
                  ref="file"
                  accept="image/*"
                  placeholder="Choose a file or drop it here..."
                  @change="selectedGuestCard('personalImg', imageSrc)"
                  drop-placeholder="Drop file here..."
                >
                </b-form-file>
                <p class="text-center">
                  <small>Maximum upload files size: 500KB</small>
                </p>
                <div
                  class="alert alert-danger m-b-0"
                  style="width:75%; margin-left:12.5%;"
                  v-if="imgError"
                >
                  Image has exceeded maximum limit
                </div>
                <div style="text-align:center;">
                  <a
                    data-bs-toggle="modal"
                    style="cursor: pointer;"
                    data-bs-target="#gc_modal_home"
                    >Choose Another Image
                    <i class="material-icons" style="vertical-align: middle; "
                      >keyboard_arrow_right</i
                    ></a
                  >
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <!-- Guest Card Image Options Modal -->
    <div
      class="modal"
      id="gc_modal_home"
      tabindex="-1"
      role="dialog"
      aria-labelledby="preview"
      aria-hidden="true"
      size="xl"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="gc_options">
          <div class="modal-body">
            <section class="row form-group">
              <div class="col-xs-12 col-md-12">
                <div id="BrochureFanPanel">
                  <div class="panel panel-grey panel-cta m-b-0">
                    <div class="modal-header text-center">
                      <button
                        type="button"
                        class="btn-close float-end"
                        style=" margin: 0;"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      > 
                      </button>
                      <div class="text-center pt-3">
                        <h3>Guest Card Image Options</h3>
                      </div>
                    </div>
                    <div class="panel-body">
                      <section class="brochure-display">
                        <div class="row">
                          <div
                            v-for="img in guestCardDesigns"
                            :key="img.cardDesign"
                            style="width: 33%"
                          >
                            <img
                              :src="img.url"
                              alt="Gift Card"
                              style="width: 100%; border-radius: 12%;"
                              v-on:click="
                                selectedGuestCard(img.cardDesign, img.urlLarge)
                              "
                              class="pb-3 pl-2 pr-2"
                              :class="{
                                chosenCard: card_design === img.cardDesign
                              }"
                            />
                          </div>
                        </div>
                      </section>
                    </div>
                    <div class="modal-footer pt-0 mt-0">
                      <button
                        type="button"
                        class="btn btn-secondary btn-lg"
                        data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <!-- View Iamge Modal -->
    <div
      class="modal"
      id="img_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="preview"
      aria-hidden="true"
      size="xl"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="gc_options">
          <div class="modal-body">
            <section class="row form-group">
              <div class="col-xs-12 col-md-12">
                <div id="BrochureFanPanel">
                  <div class="panel panel-grey panel-cta m-b-0">
                    <div class="modal-header text-center">
                      <h4>{{ $store.state.user.couple_title }}</h4>
                      <button
                        type="button"
                        class="btn-close float-end"
                        style=" margin: 0;"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      > 
                      </button>
                    </div>
                    <div class="panel-body">
                      <section class="brochure-display">
                        <b-row align-content="center" >
                          <b-col sm="12" class="m-2">
                            <b-img
                              v-if="$store.state.user.couple_image_large"
                              class="modalImg"
                              center
                              fluid
                              :src="$store.state.user.couple_image_large"
                              alt="Image 1"
                            />
                            <b-img
                              v-else
                              class="modalImg"
                              center
                              fluid
                              src="https://www.trailfinders.com/graphics/weddings/upload-24px.svg"
                              alt="Image 1"
                            />
                          </b-col>
                        </b-row>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { wishlistImage } from "../../services/api";
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = error => reject(error);
  });

export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      card_design: "",
      colWidth: "12",
      guestCardDesigns: [
        {
          cardDesign: "a",
          url:
            "https://cdn.trailfinders.com/images/1502731/AdobeStock_66358333.jpeg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1502731/AdobeStock_66358333.jpeg?width=500"
        },
        {
          cardDesign: "b",
          url:
            "https://cdn.trailfinders.com/images/2226222/28470173_l.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2226222/28470173_l.jpg?width=500"
        },
        {
          cardDesign: "c",
          url:
            "https://cdn.trailfinders.com/images/1540878/Depositphotos_14443483_original.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1540878/Depositphotos_14443483_original.jpg?width=500"
        },
        {
          cardDesign: "d",
          url:
            "https://cdn.trailfinders.com/images/2659761/Depositphotos_8613539_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2659761/Depositphotos_8613539_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "e",
          url:
            "https://cdn.trailfinders.com/images/2808697/CC3YDE%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2808697/CC3YDE%20copy.jpg?width=500"
        },
        {
          cardDesign: "f",
          url:
            "https://cdn.trailfinders.com/images/2808853/iStock-1021697344%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2808853/iStock-1021697344%20copy.jpg?width=500"
        },
        {
          cardDesign: "g",
          url:
            "https://cdn.trailfinders.com/images/2261628/iStock-694429000.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2261628/iStock-694429000.jpg?width=500"
        },
        {
          cardDesign: "h",
          url:
            "https://cdn.trailfinders.com/images/2614240/AWL_KEN8986AW.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2614240/AWL_KEN8986AW.jpg?width=500"
        },
        {
          cardDesign: "i",
          url:
            "https://cdn.trailfinders.com/images/2711224/Depositphotos_190793980_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2711224/Depositphotos_190793980_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "j",
          url:
            "https://cdn.trailfinders.com/images/2310049/KY52M8.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2310049/KY52M8.jpg?width=500"
        },
        {
          cardDesign: "k",
          url:
            "https://cdn.trailfinders.com/images/2641471/iStock-892407318%20EDITED.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2641471/iStock-892407318%20EDITED.jpg?width=500"
        },
        {
          cardDesign: "l",
          url:
            "https://cdn.trailfinders.com/images/2224868/Depositphotos_138170998_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2224868/Depositphotos_138170998_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "m",
          url:
            "https://cdn.trailfinders.com/images/1849074/Depositphotos_6536858_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1849074/Depositphotos_6536858_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "n",
          url:
            "https://cdn.trailfinders.com/images/1811433/Depositphotos_135617220_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1811433/Depositphotos_135617220_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "o",
          url:
            "https://cdn.trailfinders.com/images/2158118/Depositphotos_182896130_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2158118/Depositphotos_182896130_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "p",
          url:
            "https://cdn.trailfinders.com/images/2814604/TCPB0J%20copy.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2814604/TCPB0J%20copy.jpg?width=500"
        },
        {
          cardDesign: "q",
          url:
            "https://cdn.trailfinders.com/images/2705938/artem-beliaikin-v6kii3H5CcU-unsplash.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2705938/artem-beliaikin-v6kii3H5CcU-unsplash.jpg?width=500"
        },
        {
          cardDesign: "r",
          url:
            "https://cdn.trailfinders.com/images/1928235/champagne_glasses.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1928235/champagne_glasses.jpg?width=500"
        },
        {
          cardDesign: "s",
          url:
            "https://cdn.trailfinders.com/images/2158048/Depositphotos_140886176_xl-2015.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2158048/Depositphotos_140886176_xl-2015.jpg?width=500"
        },
        {
          cardDesign: "t",
          url:
            "https://cdn.trailfinders.com/images/2833729/MCB%20Wilhelm%20Gunkel.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/2833729/MCB%20Wilhelm%20Gunkel.jpg?width=500"
        },
        {
          cardDesign: "u",
          url:
            "https://cdn.trailfinders.com/images/1896994/courtney-hedger-336844-unsplash.jpg?width=300",
          urlLarge:
            "https://cdn.trailfinders.com/images/1896994/courtney-hedger-336844-unsplash.jpg?width=500"
        }
      ],
      image: null,
      imageS: null,
      imgError: false
    };
  },
  props: ["screenWidth"],
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imageS = value;
            })
            .then(() => {
              this.updateImage(this.imageS);
            })
            .catch(() => {
              this.imageS = {};
            });
        } else {
          this.imageS = {};
        }
      }
    }
  },
  methods: {
    async updateImage(img) {
      this.imgError = false;
      if (
        (this.$refs.file.files[0] &&
          this.$refs.file.files[0].size < 500 * 500) ||
        this.card_design !== "download"
      ) {
        let res = await wishlistImage(
          this.$store.state.wishlistType,
          this.$store.state.user._id,
          { data: img }
        );
        if (res.error) {
          this.imgError = true;
        } else {
          this.$store.dispatch("setUserAction", res.data);
        }
      } else {
        this.imgError = true;
      }
    },
    selectedGuestCard(img, src) {
      this.card_design = img;
      this.imageS = src;
      this.updateImage(this.imageS);
    }
  },
  mounted() {
    this.meta.loaded = true;
    if (this.screenWidth <= 1240) {
      this.colWidth = "6";
    } else {
      this.colWidth = "12";
    }
  }
};
</script>
<style>
.express-vue-temp .modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1080;
  display: none;
  width: 100%;
  height: 100%;
  overflow: scroll;
  outline: 0;
}
.designs {
  border-radius: 15%;
  padding-bottom: 20px;
}
.designs:hover {
  cursor: pointer;
}
.chosenCard {
  opacity: 0.5;
}
#gc_modal_home .btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
#gc_modal_home .btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.avatarImg {
  max-width: 350px !important;
  max-height: 300px !important;
  border-radius: 3% !important;
}

.modalImg {
  max-width: 700px !important;
  max-height: 600px !important;
  border-radius: 3% !important;
}
@media only screen and (max-width: 1024px) {
  .avatarImg {
    max-width: 100% !important;
    max-height: 300px !important;
    border-radius: 3% !important;
  }
  .modalImg {
    max-width: 100% !important;
    max-height: 300px !important;
    border-radius: 3% !important;
  }
}
</style>
